import './index.scss';
import React, { PropTypes } from 'react';
import PageLayout from '../';
import AppErrorNotification from '../../AppErrorNotification';

const ManagePageLayout = React.createClass({
    propTypes: {
        children: PropTypes.oneOfType([PropTypes.object, PropTypes.array])
    },
    render: function() {
        return <PageLayout mode="manage">
            <div className="manage-mode-inner-wrapper">
                <div className="pure-g">
                    <div className="pure-u-1-1">
                        <AppErrorNotification />
                    </div>
                </div>
                
                {this.props.children}
            </div>
        </PageLayout>;
    }
});

export default ManagePageLayout;


// WEBPACK FOOTER //
// ./src/components/common/PageLayout/Manage/index.jsx